import React from 'react';
import SRC from '@Theme/images/new-layout.png';
import './coupon.css';

function _CouponTemp() {
  return (
    <div className="onsite-coupon-layout">
      <div className="onsite-coupon-texts-box">
        <span className="onsite-message-title">Message Title</span>
        <span className="onsite-message-body">Message body</span>
      </div>
      <input />
      <img src={SRC} width="100%" />
    </div>
  );
}

export { _CouponTemp };
